/** @format */
import {
    CarouselStyle,
    UseCarouselProps,
    UseCarouselRotateProps,
} from '@toucan/client/shared/hooks/use-carousel';

export const isRotationStyle = (
    props: UseCarouselProps
): props is UseCarouselRotateProps => {
    return props.carouselStyle === CarouselStyle.ROTATE;
};
